export const defaultSettingsMetadataFilePath = "settings.gadget.ts";
export const settingsMetadataTypeName = "GadgetSettings";
